import { PLATFORM_FEATURES } from '@/lib/constants/features';
import { useSessionStore } from '@/store/sessionStore';

export function useFeatures() {
  const user = useSessionStore(s => s.user);

  function isFeatureEnabled(featureId: string): boolean {
    return Boolean(
      user?.company?.enabledFeatures?.some(f => f.id === featureId),
    );
  }

  return {
    isFeatureEnabled,
    isTracingAiEnabled: isFeatureEnabled(PLATFORM_FEATURES.TRACING_AI),
    isAuditAiEnabled: isFeatureEnabled(PLATFORM_FEATURES.AUDIT_AI),
    isCapaEnabled: isFeatureEnabled(PLATFORM_FEATURES.CAPA),
    isCapaBasicEnabled: isFeatureEnabled(PLATFORM_FEATURES.CAPA_BASIC),
    isCapaAdvancedEnabled: isFeatureEnabled(PLATFORM_FEATURES.CAPA_ADVANCED),
    isCapaV2Enabled: isFeatureEnabled(PLATFORM_FEATURES.CAPA_V2),
    isCascadeTracingEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.CASCADE_TRACING,
    ),
    isCertifiedMaterialsManagementEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.CERTIFIED_MATERIALS_MANAGEMENT,
    ),
    isCompanyProfilesEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.COMPANY_PROFILES,
    ),
    isEntityScreeningV2Enabled: isFeatureEnabled(
      PLATFORM_FEATURES.ENTITY_SCREENING_V2,
    ),
    isItcIntegrationEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.ITC_INTEGRATION,
    ),
    isKharonEntityListEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.KHARON_ENTITY_LIST,
    ),
    isKharonV2Enabled: isFeatureEnabled(PLATFORM_FEATURES.KHARON_V2),
    isNewStyleStructureEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.NEW_STYLE_STRUCTURE,
    ),
    isProductMappingEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.PRODUCT_MAPPING,
    ),
    isSlcpAssessmentEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.SLCP_ASSESSMENT,
    ),
    isSupplyChainMappingProductStoryEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.SUPPLY_CHAIN_MAPPING_PRODUCT_STORY,
    ),
    isViewNetworkUsersInfoEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.VIEW_NETWORK_USERS_INFO,
    ),
    isDropBoxEnabled: isFeatureEnabled(PLATFORM_FEATURES.DROP_BOX),
    isSupplierQuestionnaireEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.SUPPLIER_QUESTIONNAIRE,
    ),
    isOrdersHubEnabled: isFeatureEnabled(PLATFORM_FEATURES.ORDERS_HUB),
  };
}
